import { create } from 'zustand'
import { configApi } from '@/api/configApi'

interface AppConfigState {
  /** Whether the paid-billing flows (checkout, plan change, cancel) are live. */
  billingEnabled: boolean
  loaded: boolean
  load: () => Promise<void>
}

let inflight: Promise<void> | null = null

export const useAppConfigStore = create<AppConfigState>((set, get) => ({
  // Fail closed: until the API answers, billing stays disabled so the UI never
  // offers a checkout the backend would reject with BILLING_DISABLED.
  billingEnabled: false,
  loaded: false,

  async load() {
    if (get().loaded) return
    if (inflight) return inflight

    inflight = configApi
      .get()
      .then((config) => {
        set({ billingEnabled: config.billing_enabled === true, loaded: true })
      })
      .catch(() => {
        set({ billingEnabled: false, loaded: true })
      })
      .finally(() => {
        inflight = null
      })

    return inflight
  },
}))
